<template>
    <!--<UnderConstruction /> -->
  <div class="w-100">
    <div class="p-md-3 w-100 contact-container" >
      <div class="row m-0 w-100 p-0">
        <div class="col-md-3 p-0 m-0 " style="z-index: 1;">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title">Phone Support</h4> <br/>
              <p>Monday-Friday 8:30am - 5:00pm PST <br/>Saturday & Sunday 8:00am - 4:00pm</p>
              <p>For after hour support, please leave us a voice message or fill out the form on our contact page and a member of
                our team will get back to you the next business day.</p>
              <p>+ 1 818 798-5558</p>
              <hr/>
              <h4 class="header-title mb-0 mt-3">Our address</h4><br/>
              <p>9531 Cozycroft AVE, Chatsworth CA 91311</p>
              <a href="tel:8187985558">
                <button type="button" class="btn btn-primary text-dark me-2 mb-2 pe-3 ps-3"><i class="fa-duotone fa-solid fa-phone-volume me-1"></i> Call Us</button>
              </a>
              <a target="_blank" :href="constants.SITEURL+'/contact-us'">
                <button type="button" class="btn btn-secondary text-white mb-2 pe-3 ps-3"><i class="fa-duotone fa-solid fa-envelope me-1"></i> Leave a Message</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="chartdiv" style="height: 840px;">
    </div>
  </div>
  
  
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
//import UnderConstruction from '../components/UnderConstruction';
import Mixin from '../mixins/global.mixin'
import * as am5 from '@amcharts/amcharts5';
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
//import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import appConstants from '@/constants/app.constants';
  
export default defineComponent({
  name: 'CustomerSupport',
  mixins: [Mixin],
  setup() {
    return {
      constants: appConstants
    }
  },
  data() {
    return {
      chart: null,
      mapBackgroundColor: '#EBF1F2',
      customerBubbleSeries: null
    }
  },
  components: {
    // UnderConstruction
  },
  methods: {
    createMaksMarker: function (root) {
      var circleTemplate = am5.Template.new({
        tooltipText: "{name}"
      });

      this.customerBubbleSeries = this.chart.series.push(
        am5map.MapPointSeries.new(root, {
          calculateAggregates: true,
          valueField: "value",
        })
      );

      this.customerBubbleSeries.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 10,
            templateField: "circleTemplate"
          }, circleTemplate)
        });
      });

      this.customerBubbleSeries.set("heatRules", [{
        target: circleTemplate,
        min: 5,
        max: 20,
        key: "radius",
        dataField: "value"
      }]);
      
      this.customerBubbleSeries.data.setAll([{
        id: 'maks',
        name: 'Maks Enterprises LLC',
        value: 1,
        circleTemplate: { fill: '#51E1E5' },
        geometry: {
          type: "Point",
          coordinates: [ -118.5821375, 34.2436019]
        }
      }]);
    },
    createAmCharts5Map: function () {
      var root = null;
      am5.ready(() => {
        //console.log(am5.Root);
        am5.disposeAllRootElements();
        root = am5.Root.new("chartdiv");
        root.setThemes([
          am5themes_Animated.new(root)
        ]);

        this.chart = root.container.children.push(
          am5map.MapChart.new(root, {
            homeZoomLevel: 12,
            homeGeoPoint: {
              longitude: -100.17232754112253,
              latitude: 39.72231405286368
            },
            projection: am5map.geoMercator()
          })
        );

        var backgroundSeries = this.chart.series.push(am5map.MapPolygonSeries.new(root, {}));
        backgroundSeries.mapPolygons.template.setAll({
          fill: root.interfaceColors.get("alternativeBackground"),
          fillOpacity: 0,
          strokeOpacity: 0,
        });

        backgroundSeries.data.push({
          geometry: am5map.getGeoRectangle(90, 180, -90, -180)
        });

        var polygonSeries = this.chart.series.push(
          am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow,
            exclude: ["AQ"]
          })
        );

        polygonSeries.mapPolygons.template.setAll({
          //fill: root.interfaceColors.get("alternativeBackground"),
          fill: am5.color(this.mapBackgroundColor),
          strokeWidth: 0.5,
          stroke: root.interfaceColors.get("background")
        });
        
        polygonSeries.events.on("datavalidated", () => {
          this.chart.goHome();
        });

      }); // end am5.ready() 

     
      return root;
      
    },
    initMap: async function () {
      let root = await Promise.all([this.createAmCharts5Map()]);
      if (root.length) {
        this.createMaksMarker(root[0]);
        
      }
    }
  },
  mounted() {
    
    //this.createMaksMarker(root);
    /*if (root.length) {
      this.createMaksMarker(root);
      this.toggleFullScreenSpinner(false);
      console.log('test');
    }*/

    setTimeout( () => {
      this.initMap();
      this.toggleFullScreenSpinner(false);
      //this.createMaksMarker(root);
    }, 500);

    


  },
  
});
</script>
    